import type { FeatureProvider } from "@protontech/autofill/features/v1";
import type { Ruleset } from "@protontech/fathom";
import { ruleset } from "@protontech/fathom";
import { getBaseRules, getRulesProvider } from "./rules/v1";
import type { AnyRule, DetectionClass, HeuristicDetectionClass, ModelName, ModelProvider } from "./types";
import { detectionClasses } from "./types";
import { prepass } from "./utils/prepass";

type RulesetRegistry<T extends ModelName = string> = {
  providers: Record<T, ModelProvider>;
  make: (key: T) => Ruleset;
};

export const rulesetMaker = (modelProvider: ModelProvider) => {
  const featureProvider = Object.fromEntries(Object.keys(modelProvider).map((klass) => [klass, modelProvider[klass as DetectionClass | HeuristicDetectionClass].featureComputer])) as FeatureProvider;
  const rulesProvider = getRulesProvider(featureProvider);
  const rules: AnyRule[] = [...getBaseRules(featureProvider), ...detectionClasses.flatMap((klass) => rulesProvider[klass])];
  const models = new Map(detectionClasses.map((klass) => [klass, modelProvider[klass].model]));
  return ruleset(rules, models, prepass);
};

export const createRulesetRegistry = <T extends ModelName>(providers: Record<T, ModelProvider>): RulesetRegistry<T> => ({
  providers,
  make: (key) => rulesetMaker(providers[key]),
});
